module.exports = __webpack_public_path__ + "static/media/234-australia.8c28804e.svg";